module.exports = __webpack_public_path__ + "static/media/2.dd0f52c8.jpg";